// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7d479eee","453":"b1fdbc59","732":"d0aba1f0"}[chunkId] + ".chunk.js";
};